import { Segmented } from 'antd';
import { useState } from 'react';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import AppointmentLookupPage from './AppointmentLookup/AppointmentLookup.page';

const EHRIntegrations = ({ isMinimized }) => {
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('ehrIntegrationsSegment') || 'Appointment Lookup';
  });

  const segmentedOptions = [
    {
      label: 'Appointment Lookup',
      value: 'Appointment Lookup',
    },
  ];

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    storeInLocal('ehrIntegrationsSegment', value);
  };

  return (
    <div className="page-wrapper">
      <div className="lg:flex gap-3 justify-between py-3 items-center">
        <Segmented
          options={segmentedOptions}
          value={activeButton}
          onChange={(value) => {
            handleSegmentedTabChange(value);
          }}
        />
      </div>
      <div>
        {activeButton === 'Appointment Lookup' && <AppointmentLookupPage />}
      </div>
    </div>
  );
};

export default EHRIntegrations;
